import { BaseNameSideItem } from '@Enum/index';

import { ReactComponent as MyRequestGradientIcon } from '@Icons/menu/gradient/my-request.svg';
import { ReactComponent as DashboardGradientIcon } from '@Icons/menu/gradient/dashboard.svg';
import { ReactComponent as ApprovalsGradientIcon } from '@Icons/menu/gradient/approvals.svg';
import { ReactComponent as ReportsGradientIcon } from '@Icons/menu/gradient/reports.svg';
import { ReactComponent as ProcurementGradientIcon } from '@Icons/menu/gradient/procurement.svg';
import useRoutePrefix from '@Hooks/useRoutePrefix';
import { MRItems, ESSItems } from '../components/items/SideMenuItems';
import { MenuItem } from '../types';

const iconMapper: { [key: string]: React.ReactNode } = {
  [BaseNameSideItem.MY_REQUESTS]: <MyRequestGradientIcon />,
  [BaseNameSideItem.DASHBOARD]: <DashboardGradientIcon />,
  [BaseNameSideItem.APPROVALS]: <ApprovalsGradientIcon />,
  [BaseNameSideItem.REPORTS]: <ReportsGradientIcon />,
  [BaseNameSideItem.PROCUREMENT]: <ProcurementGradientIcon />,
};

const useUpdateItems = (selectedItem: string[] | undefined): MenuItem[] => {
  const routePrefix = useRoutePrefix();
  const items = routePrefix === 'mr' ? MRItems : ESSItems;

  if (Array.isArray(selectedItem)) {
    const selectedKey = selectedItem[0];
    return items.map((item) =>
      item?.key === selectedKey
        ? { ...item, icon: iconMapper[selectedKey] }
        : item
    );
  }

  return items;
};

export default useUpdateItems;
